import axios from "axios";
import { BaseApiService } from "shared/api";

export class LogErrorsService extends BaseApiService {
  async write(payload) {
    try {
      return await axios.post(this.ENDPOINTS.logs.write, payload);
    } catch (error) {
      console.error(error);
    }
  }
}

export default new LogErrorsService();
